import { CustomRoute } from "@router/types";
import authCodeMap from "@/dataBase/authCodeMap";
const routes: Array<CustomRoute> = [
  // {
  //   path: "/dataAnalysis",
  //   name: authCodeMap.dataAnalysis,
  //   component: (): any => import("@/modules/router.vue"),
  //   redirect: "/dataAnalysis/user/index",
  //   meta: {
  //     title: "数据分析",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: true,
  //     authCode: authCodeMap.dataAnalysis,
  //   },
  //   children: [
  //     {
  //       path: "asset",
  //       name: authCodeMap.asset_overview,
  //       component: (): any => import("@/modules/dataAnalysis/pages/assetsOverview/index.vue"),
  //       meta: {
  //         title: "资产_资产概览",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.asset_overview,
  //       },
  //     },
  //     {
  //       path: "user",
  //       name: authCodeMap.dataAnalysis_user,
  //       component: (): any => import("@/modules/dataAnalysis/pages/user/index.vue"),
  //       meta: {
  //         title: "资产_用户资产_用户数据",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.dataAnalysis_user,
  //       },
  //       // children: [
  //       //   {
  //       //     path: "index",
  //       //     name: authCodeMap.dataAnalysis_user_index,
  //       //     component: (): any => import("@/modules/dataAnalysis/pages/user/components/index.vue"),
  //       //     meta: {
  //       //       title: "数据分析_用户数据",
  //       //       hidden: true,
  //       //       needLogin: true,
  //       //       authCode: authCodeMap.dataAnalysis_user_index,
  //       //     },
  //       //   },
  //       //   {
  //       //     path: "prop",
  //       //     name: authCodeMap.dataAnalysis_user_prop,
  //       //     component: (): any => import("@/modules/dataAnalysis/pages/user/components/prop.vue"),
  //       //     meta: {
  //       //       title: "数据分析_用户数据",
  //       //       hidden: true,
  //       //       needLogin: true,
  //       //       authCode: authCodeMap.dataAnalysis_user_prop,
  //       //     },
  //       //   },
  //       // ],
  //     },
  //     {
  //       path: "content",
  //       name: authCodeMap.dataAnalysis_content,
  //       component: (): any => import("@/modules/dataAnalysis/pages/content/content.vue"),
  //       meta: {
  //         title: "资产_内容资产_内容数据",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.dataAnalysis_content,
  //       },
  //       // children: [
  //       //   {
  //       //     path: "interactive",
  //       //     name: authCodeMap.dataAnalysis_content_interactive,
  //       //     component: (): any => import("@/modules/dataAnalysis/pages/content/components/interactive.vue"),
  //       //     meta: {
  //       //       title: "数据分析_内容数据",
  //       //       hidden: true,
  //       //       needLogin: true,
  //       //       authCode: authCodeMap.dataAnalysis_content_interactive,
  //       //     },
  //       //   },
  //       //   {
  //       //     path: "visit",
  //       //     name: authCodeMap.dataAnalysis_content_visit,
  //       //     component: (): any => import("@/modules/dataAnalysis/pages/content/components/visit.vue"),
  //       //     meta: {
  //       //       title: "数据分析_内容数据",
  //       //       hidden: true,
  //       //       needLogin: true,
  //       //       authCode: authCodeMap.dataAnalysis_content_visit,
  //       //     },
  //       //   },
  //       // ],
  //     },
  //     {
  //       path: "dataCenter",
  //       name: authCodeMap.dataCenter_data,
  //       component: (): any => import("@/modules/dataAnalysis/pages/dataCenter/data.vue"),
  //       meta: {
  //         title: "资产_数据中心_数据概览",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.dataCenter_data,
  //       },
  //     },
  //     {
  //       path: "dataCenter/user",
  //       name: authCodeMap.dataCenter_user,
  //       component: (): any => import("@/modules/dataAnalysis/pages/dataCenter/user.vue"),
  //       meta: {
  //         title: "资产_数据中心_用户分析",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.dataCenter_user,
  //       },
  //     },
  //     {
  //       path: "dataCenter/content",
  //       name: authCodeMap.dataCenter_content,
  //       component: (): any => import("@/modules/dataAnalysis/pages/dataCenter/content.vue"),
  //       meta: {
  //         title: "资产_数据中心_内容分析",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.dataCenter_content,
  //       },
  //     },
  //     {
  //       path: "dataCenter/order",
  //       name: authCodeMap.dataCenter_order,
  //       component: (): any => import("@/modules/dataAnalysis/pages/dataCenter/order.vue"),
  //       meta: {
  //         title: "资产_数据中心_服务订单分析",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.dataCenter_order,
  //       },
  //     },
  //   ],
  // },
];
export default routes;
